/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_SUB_COLLECTION_ITEM = {
  id: 'subscriptions_collection',
  screenId: 'met-sub-collection',
  label: 'Cobranza',
  description: 'Cuotas con saldo pendiente y mora al día de hoy.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Seguís cuotas de suscripción ya facturadas que todavía no se cobraron por completo: cuántas están vencidas, cuánto falta cobrar y quiénes son los principales deudores.',
      },
      {
        title: 'Qué mirar',
        bullets: [
          'En mora — vencidas respecto a la fecha de vencimiento de la factura.',
          'Pendientes a vencer — con saldo pero todavía no vencidas.',
          'Top deudores — contratos con más saldo pendiente.',
          'La tabla detalla período, vencimiento, días de atraso y saldo.',
        ],
      },
    ],
  },
}
